import Vue from "vue";
import VueRouter from "vue-router";
import Weekly from "../views/Weekly.vue";

Vue.use(VueRouter);

const routes = [{
  path: "/",
  name: "weekly",
  component: Weekly
}];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
